export default __webpack_public_path__ + "static/media/24-picnic-pic-2021.633e5f8b.jpeg";